export default "__VITE_ASSET__GSp$$8e4__"